import aclass from "./a-class@2x.png";
import bclass from "./b-class@2x.png";
import c1class from "./c1-class@2x.png";
import c2class from "./c2-class@2x.png";
import d1class from "./d1-class@2x.png";
import d2class from "./d2-class@2x.png";
import eclass from "./e-class@2x.png";
import g1class from "./g1-class@2x.png";
import g2class from "./g2-class@2x.png";
import wclass from "./w-class@2x.png";
import zclass from "./z-class@2x.png";

export default {
  A: aclass,
  A1: aclass,
  A2: aclass,
  B: bclass,
  B1: bclass,
  B2: bclass,
  C: c1class,
  C1: c1class,
  C2: c2class,
  D1: d1class,
  D2: d2class,
  E: eclass,
  G1: g1class,
  G2: g2class,
  W: wclass,
  Z: zclass,
  Z1: zclass,
  Z2: zclass,
  Z3: zclass,
};
